<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('helloJsPage.title')" class="pb-0"/>

    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 col-md-12 text-center">
            <p>{{ $t("helloJsPage.learnings") }}</p>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleTwoAge") }}</span>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleTwoLevel") }}</span>
            <span class="badge badge-pill bg-black mr-2">{{ $t("coursesPage.moduleTwoPrice") }}</span>
          </div>
        </div>
      </div>
    </section>

   <courseDetails 
    :scheduleText="$t('helloJsPage.schedule')"
    :locationText="$t('helloJsPage.location')"
    :priceText="$t('helloJsPage.price')"
   />

   <courseCurricula 
    :curricula="$t('helloJsPage.curricula')"
    :imgUrl="require('@/assets/images/curricula/hello-javascript.png')"
   /> 

    <cta :ctaText="$t('cta.helloJsText')" :ctaBtn="$t('cta.buttonText')" :ctaRoute="'/register'"/>

    <featured />

    <footerJSK />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import courseDetails from "./../components/courseDetails.vue";
import courseCurricula from "./../components/courseCurricula.vue";
import cta from "./../components/cta.vue";
import featured from "./../components/featured.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "HelloJavaScript",
  components: {
    navMenu,
    hero,
    courseDetails,
    courseCurricula,
    cta,
    featured,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
